export default class Share {
	constructor(el) {
		this.el = el;
		this.items = null;
		this.init();
	}

	init() {
		this.items = this.el.querySelectorAll("[js-share-item]");
		this.currentUrl = window.location.href;
		this.title = this.el.getAttribute("js-share-title");
		this.createLinks();
	}

	createLinks() {
		this.items.forEach((item) => {
			const type = item.getAttribute("js-share-type");
			this.createLink(item, type);
		});
	}

	createLink(item, type) {
		let link = "";
		switch (type) {
			case "share":
				link = `mailto:?subject=${encodeURIComponent(this.title)}&body=${encodeURIComponent(
					"Check this out :- "
				)} : ${encodeURIComponent(this.currentUrl)}`;
				item.setAttribute("href", link);
				break;

			case "mail":
				link = `mailto:?subject=${encodeURIComponent(this.title)}&body=${encodeURIComponent(
					"Check this out :- "
				)} : ${encodeURIComponent(this.currentUrl)}`;
				item.setAttribute("href", link);
				break;

			case "copy":
				item.addEventListener("click", () => {
					navigator.clipboard.writeText(this.currentUrl);
				});
		}
	}
}
